import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from "@azure/msal-angular";
import { SessionStorage } from 'ngx-webstorage';
import { AppService } from '../../app.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  @SessionStorage() public user;
  @SessionStorage() public config;
  public navigations: any = [];
  public currentYear: number;

  constructor(
    private router: Router,
    private appService: AppService,
    private authService: MsalService
  ) { }

  ngOnInit() {
    const d = new Date();
    this.currentYear = d.getFullYear();
    this.navigations = [
      { title: 'Dashboard', link: '/admin/dashboard' },
      { title: 'Projects', link: '/admin/project' },
      { title: 'Activities', link: '/admin/tasks' },
      { title: 'Total Employees', link: '/admin/employees', queryParams: { totalemployees: 'true' } },
      //{ title: 'Employees', link: '/admin/employees' },
      { title: 'Audit Logs', link: '/admin/audit' },
      { title: 'Notifications', link: '/admin/notification' },
      { title: 'Reports', link: '/admin/reports' },
    ];

    if (this.config.businessUnit === 'accenture') {
      this.navigations.splice(4, 0, { title: 'Locked Timesheets', link: '/admin/locked-timesheet' });
    }
  }

  navigateTo(nav: any) {
    if (nav.queryParams) {
      this.router.navigate([nav.link], { queryParams: nav.queryParams });
    } else {
      this.router.navigate([nav.link]);
    }
  }

  /** Function to logout and navigate to login */
  logOut() {
    this.authService.logout();
    this.appService.logOut().subscribe(
      (res) => {
        this.router.navigate(['/login']);
      },
      (error) => {
        this.router.navigate(['/login']);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/common/sidebar/sidebar.component.ts